import React, { useState, Fragment } from "react";
import DeliveryStatus from "./DeliveryStatus";

const ChatContent = ({ chatData }) => {
  const [isConversationOpen, setIsConversationOpen] = useState(true);

  if (!Array.isArray(chatData)) {
    return <div>No chat data</div>;
  }

  return (
    <div className="flex flex-col gap-y-4">
      {chatData.map((itemChat, id) => {
        if (itemChat.isConversation) {
          return (
            <div key={id}>
              <div className="flex flex-col gap-y-3 bg-lightestGray px-4 pt-4 pb-2 rounded-2xl border border-lighterGray mh-box-shadow w-fit max-w-[87%]">
                <div className="flex justify-between">
                  <div className="flex gap-x-2 items-center">
                    <i className="fa-solid fa-phone text-darkGray"></i>
                    <p className="text-h3 text-darkGray">Phone Call</p>
                  </div>
                  <button
                    className="text-h4 font-bold text-darkBlue"
                    onClick={() => setIsConversationOpen(!isConversationOpen)}
                  >
                    Full Conversation
                  </button>
                </div>
                <div
                  className={`bg-lightestBlue px-4 py-3 rounded-2xl overflow-hidden ${isConversationOpen ? "h-[140px]" : "h-full"
                    }`}
                >
                  {Array.isArray(itemChat.message) ? (
                    itemChat.message.map((message, id) => (
                      <div className="flex flex-col gap-y-1 pb-3" key={id}>
                        <p className="text-h4 font-semiBold text-darkGray">
                          {message.userName}
                        </p>
                        {message.messages.map((item, id) => (
                          <p className="text-h3 text-darkestSlate" key={id}>
                            {item}
                          </p>
                        ))}
                      </div>
                    ))
                  ) : (
                    <p className="text-h3 text-darkestSlate">
                      {itemChat.message}
                    </p>
                  )}
                </div>
                <div className="flex justify-end">
                  <span className="text-h4 font-semiBold text-darkestSlate">
                    4 min
                  </span>
                </div>
              </div>
            </div>
          );
        } else
          return (
            <Fragment key={id}>
              {(() => {
                const rawDir = String((itemChat as any)?.direction || '').toLowerCase();
                const isClient = rawDir === 'inbound'
                  ? true
                  : rawDir === 'outbound'
                    ? false
                    : !itemChat.isMyMessage;

                if (!isClient) {
                  // Realtor 
                  return (
                    <div className="bg-lightestBlue px-4 pt-4 pb-2 rounded-2xl w-fit max-w-[87%] self-end">
                      <p className="text-h3 text-darkestSlate pb-2">
                        {itemChat.message as any}
                      </p>
                      <DeliveryStatus 
                        channel={(itemChat as any).channel}
                        deliveryStatus={(itemChat as any).deliveryStatus}
                        deliveredAt={(itemChat as any).deliveredAt}
                        deliveryError={(itemChat as any).deliveryError}
                      />
                      <div className="flex justify-end">
                        <span className="text-h4 font-semiBold text-darkestSlate">
                          {itemChat.minAgo}
                        </span>
                      </div>
                    </div>
                  );
                }

                // Client
                return (
                  <div className="bg-lightestGray px-4 pt-4 pb-2 rounded-2xl border border-lighterGray mh-box-shadow w-fit max-w-[87%]">
                    <p className="text-h3 text-darkestSlate pb-2">
                      {itemChat.message as string}
                    </p>
                    <div className="flex justify-end">
                      <span className="text-h4 font-semiBold text-darkestSlate">
                        {itemChat.minAgo}
                      </span>
                    </div>
                  </div>
                );
              })()}
             
            </Fragment>
          );
      })}
    </div>
  );
};

export default ChatContent;
